import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceCreateCalendarHolidaysNotificationState = createStateReducer(
  initialState,
  {
    [events.createCalendarHolidaysSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "createCalendarHolidays",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.createCalendarHolidaysFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "createCalendarHolidays",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceCreateCalendarHolidaysNotificationState };
